export default "__VITE_ASSET__85ab59fb__"